<template>
  <v-dialog
    v-model="initialModal"
    max-width="100vw"
    width="550px"
    class="productModal youReprocesosProductModal"
    transition="dialog-bottom-transition"
    :content-class="'productModal youReprocesosProductModal inital-modal'"
    @input="handleDialogChange"
  >
    <template v-if="useActivator" #activator="{}">
      <div class="searchModelDialog">
        <v-text-field
            ref="searchInput"
            class="searchInputModel"
            :class="{ animated: !modelPrice && !initialModal }"
            :label="$t('general.Selecciona un modelo')"
            prepend-inner-icon="$fi-search"
            solo
            hide-details
            rounded
            color="bannerBackground"
            @click="openModal"
            @focus="openModal"
            @input="openModal"
        ></v-text-field>
      </div>
    </template>
    <v-card color="dialogModelSearch-card bannerBackground">
      <v-card-text>
        <v-row>
          <v-col>
            <div class="head">
              {{ $t("general.selectModelOrDraft") }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <model-search is-on-modal :focus-input="initialModal" @model-selected="handleModelSelected"></model-search>
          </v-col>
        </v-row>
        <v-row v-if="!isYouReprocesos && activeBorradores">
          <v-col class="w-100">
            <cotizador-btn disabled outlined content-class="w-100">
              {{ $t("draftLiteral.loadDraft") }}
            </cotizador-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ModelSearch from "@/components/basic/modelSearch.vue";
import { mapGetters } from 'vuex';

export default {
    components: {
        ModelSearch
    },
    props: {
        activeDialog: {
            type: Boolean,
            default: false
        },
        useActivator: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
          initialModal: false,
          firstModel: false
        }
  },
    computed: {
        ...mapGetters("config", ["isYouReprocesos", "activeBorradores", "key", "youReprocesosSession"]),
      ...mapGetters("modelo", ["modelPrice"]),
        hasKeyActive() {
          return this.key || this.youReprocesosSession;
      },
        
    },
    watch: {
        activeDialog(newValue) {
            this.initialModal = newValue;
        },
        initialModal(newValue) {
            this.$emit("update:activeDialog", newValue);
        },
        hasKeyActive(newValue) {
            if (newValue) {
                this.initialModal = true;
            }
            else {
                this.initialModal = false;
            }
        },
    },
    mounted() {
      // Retardo breve para forzar la renderización del contenido
      setTimeout(() => {
        if (!this.firstModel && (this.key || this.isYouReprocesos)) {
          
        this.initialModal = true;
        }
      }, 300);
    },
    methods: {
      handleModelSelected() {
        this.initialModal = false;
        this.firstModel = true;
        this.blurInput();
      },
      handleDialogChange(value) {
          if (!value) {
              // El diálogo se está cerrando
              this.blurInput();
          }
      },
        blurInput() {
            // Quitar el foco del input cuando se cierra el modal
            if (this.$refs.searchInput) {
                this.$refs.searchInput.blur();
            }
      },
      openModal() {
        if (this.initialModal) {
          this.initialModal = false;

          setTimeout(() => {
            this.initialModal = true;
          }, 100);
        }
        else
        {
          this.initialModal = true;
        }
      }
    }
}
</script>